import { useCurrentStateAndParams } from "@uirouter/react";

import type {
    SocialChannelsParamsDefinition,
    ISocialChannelsStateDeclaration,
} from "../../app/social-channels/routes.types";

export const useSocialChannelsDataAndParams = () => {
    const { params, state }: { params: SocialChannelsParamsDefinition; state: ISocialChannelsStateDeclaration } =
        useCurrentStateAndParams();

    return {
        key: params.key as unknown as string,
        duration: (params.duration as unknown as string) ?? "28d",
        country: params.country as unknown as number,
        isWWW: params.isWWW,
        showHeader: state.data?.showHeader ?? true,
        showFilters: state.data?.showFilters ?? true,
    };
};
